import { ENRICHMENT_STATE } from '@aibees/elephant/types';
import { ButtonProps } from '@mui/material';

export enum ANALYSIS_CONTENT_TYPE {
  LINKEDIN = 'LINKEDIN_URL',
  SKILL_BASED = 'SKILL_BASED',
}

export interface SingleAnalysisContact {
  linkedinUrl: string;
}

export interface AnalysisSinglePersonResponse {
  refId: string;
  state: ENRICHMENT_STATE;
  created: string;
  content?: PersonAnalysisResult;
}

export interface PersonAnalysisResult {
  modal: ANALYSIS_CONTENT_TYPE;
  source: string;
  score: number;
  created?: string;
  selling: PersonAnalysisSelling;
  hiring?: PersonAnalysisHiring;
  assessments?: PersonAnalysisAssessments;
  status?: ANALYSIS_STATUS;
}

export interface PersonAnalysisSelling {
  email?: {
    closingLine: PersonAnalysisSalesContent;
    gif: PersonAnalysisSalesContent;
    subject: PersonAnalysisSalesContent;
    bulletPoints: PersonAnalysisSalesContent;
    greeting: PersonAnalysisSalesContent;
    complimentaryClose: PersonAnalysisSalesContent;
    emailLength: PersonAnalysisSalesContent;
    tone: PersonAnalysisSalesContent;
    salutation: PersonAnalysisSalesContent;
    messaging: PersonAnalysisSalesContent;
    personalized: Personalized;
  };
  interests?: string;
  communication?: {
    types: string[];
    descriptions: string[];
    adjectives: string[];
    whatToSay: string[];
    whatToAvoid: string[];
  };
  keyTraits: {
    risk?: string;
    abilityToSayNo?: string;
    speed?: string;
    decisionDrivers?: string;
  };
}

export interface PersonAnalysisHiring extends PersonAnalysisSelling {}

export interface PersonAnalysisAssessments {
  archetype: string;
  ocean?: {
    openness: PersonAnalysisAssessmentsScore;
    conscientiousness: PersonAnalysisAssessmentsScore;
    extraversion: PersonAnalysisAssessmentsScore;
    agreeableness: PersonAnalysisAssessmentsScore;
    emotionalStability: PersonAnalysisAssessmentsScore;
    summary: {
      descriptions: string[];
      labels?: PersonAnalysisOceanLabels[];
    };
    chartStatistics: PersonAnalysisChartStatistic[];
  };
  disc?: {
    dominance: PersonAnalysisAssessmentsScore;
    influence: PersonAnalysisAssessmentsScore;
    steadiness: PersonAnalysisAssessmentsScore;
    calculativeness: PersonAnalysisAssessmentsScore;
    summary: {
      descriptions: string[];
      labels?: PersonAnalysisDiscLabels[];
    };
    chartStatistics: PersonAnalysisChartStatistic[];
  };
}

export interface PersonAnalysisChartStatistic {
  label: string;
  level: string;
  score: number;
}

export interface PersonAnalysisAssessmentsScore {
  score: number;
  level: string;
}

export interface Personalized {
  subject: string;
  body: string;
}

export interface PersonAnalysisSalesContent {
  definition: string;
  advice: string;
  example: string;
}

export enum ANALYSIS_STATUS {
  SUCCESS = 'SUCCESS',
  SCRAPING_FAILED = 'SCRAPING_FAILED',
  PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND',
  INSUFFICIENT_DATA = 'INSUFFICIENT_DATA',
  LOW_CONFIDENCE = 'LOW_CONFIDENCE',
  ANALYSIS_FAILED = 'ANALYSIS_FAILED',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  SERVICE_NOT_AVAILABLE = 'SERVICE_NOT_AVAILABLE',
  TIMEOUT = 'TIMEOUT',
  MISSING_CONFIGURATION = 'MISSING_CONFIGURATION',
  EMPTY_RESULT = 'EMPTY_RESULT',
}

export enum PersonAnalysisDiscLabels {
  I = 'I',
  i = 'i',
  D = 'D',
  d = 'd',
  C = 'C',
  c = 'c',
  S = 'S',
  s = 's',
}

export enum PersonAnalysisOceanLabels {
  C = 'C',
  c = 'c',
  A = 'A',
  a = 'a',
  N = 'N',
  n = 'n',
  O = 'O',
  o = 'o',
  E = 'E',
  e = 'e',
}

export enum PersonalityAnalysisTabTitle {
  SALES_ANALYSIS = 'Sales',
  TALENT_ANALYSIS = 'Talent',
  BUYING_TEAM_ANALYSIS = 'Buying Team',
  PRODUCT_SERVICES_ANALYSIS = 'Product',
}

export interface Big5ProfileScore {
  name: string;
  score: number;
  colorLight: string;
  colorDark: string;
  colorText: string;
  buttonColor: ButtonProps['color'];
  text: PersonAnalysisOceanLabels;
  description: string;
}

export interface DiscProfileScore {
  name: string;
  score: number;
  color: string;
  text: PersonAnalysisDiscLabels;
  description: string;
  buttonColor: ButtonProps['color'];
  textSx: any;
}
